import React from 'react';
import Select from 'react-timezone-select';
import type { ITimezoneOption } from 'react-timezone-select';

export type TimeZoneProps = {
  label?: string;
  className?: string;
  onChange?: (value: string) => void;
  value?: string;
};

export const TimeZonePicker: React.FC<TimeZoneProps> = ({
  label,
  className,
  onChange,
  value,
}) => {
  const selectedValue =
    value || Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className={className || 'mx-auto'}>
      {label && (
        <label className="block text-sm font-medium mb-1">{label}</label>
      )}
      <Select
        className="text-tiny"
        value={{ value: selectedValue, label: selectedValue }}
        onChange={(tz: ITimezoneOption) => onChange?.(tz.value)}
      />
    </div>
  );
};
